module.exports = __webpack_public_path__ + "static/media/Dagboek-NielsTimmermans.1619a961.mp4";